module.exports = __webpack_public_path__ + "media/puzzle4_7.65308c5a.mp3";